function FullName(first, middle, last) {
    if (middle && middle.length > 0) {
        return `${first} ${middle} ${last}`;
    }
    return `${first} ${last}`;
}

export { FullName };